<div
  id="modal-window"
  class="bg-white {{ isMobile ? 'md:rounded-md' : 'rounded-md' }} flex flex-col overflow-hidden relative justify-self-center self-center pointer-events-auto"
>
  <ng-container
    #switcherRef="switcher"
    [componentsToSwitch]="modalWindowWrapper.modalWindow.componentsToSwitch"
    [sharedContext]="modalWindowWrapper.modalWindow.context"
  ></ng-container>

  @if (isCloseBtnDisplayed) {
    <button
      id="close-modal-btn"
      data-test-id="close-modal-btn"
      class="hover:bg-navy-30 absolute z-50 rounded-md w-10 h-10 right-4 top-4"
      (click)="closeModal.emit()"
    >
      <svg-icon preserveAspectRatio="none" src="close" [stretch]="true"></svg-icon>
    </button>
  }
</div>
